import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "viewBox": "-7.5 -8 2766.78125 362.94708251953125",
        "style": {
          "maxWidth": "2766.78125px"
        },
        "aria-labelled-by": ["chart-title-mermaid-1693925847428", "chart-desc-mermaid-1693925847428"],
        "role": "img",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "100%",
        "id": "mermaid-1693925847428"
      }}><title parentName="svg" {...{
          "id": "chart-title-mermaid-1693925847428"
        }}></title><desc parentName="svg" {...{
          "id": "chart-desc-mermaid-1693925847428"
        }}></desc><style parentName="svg">{`#mermaid-1693925847428 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1693925847428 .error-icon{fill:#552222;}#mermaid-1693925847428 .error-text{fill:#552222;stroke:#552222;}#mermaid-1693925847428 .edge-thickness-normal{stroke-width:2px;}#mermaid-1693925847428 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1693925847428 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1693925847428 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1693925847428 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1693925847428 .marker{fill:#333333;stroke:#333333;}#mermaid-1693925847428 .marker.cross{stroke:#333333;}#mermaid-1693925847428 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1693925847428 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1693925847428 .cluster-label text{fill:#333;}#mermaid-1693925847428 .cluster-label span{color:#333;}#mermaid-1693925847428 .label text,#mermaid-1693925847428 span{fill:#333;color:#333;}#mermaid-1693925847428 .node rect,#mermaid-1693925847428 .node circle,#mermaid-1693925847428 .node ellipse,#mermaid-1693925847428 .node polygon,#mermaid-1693925847428 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1693925847428 .node .label{text-align:center;}#mermaid-1693925847428 .node.clickable{cursor:pointer;}#mermaid-1693925847428 .arrowheadPath{fill:#333333;}#mermaid-1693925847428 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1693925847428 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1693925847428 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1693925847428 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1693925847428 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1693925847428 .cluster text{fill:#333;}#mermaid-1693925847428 .cluster span{color:#333;}#mermaid-1693925847428 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1693925847428 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}#mermaid-1693925847428 .plugingraph>*{fill:#fff!important;stroke-width:3px!important;stroke:#000!important;}#mermaid-1693925847428 .plugingraph span{fill:#fff!important;stroke-width:3px!important;stroke:#000!important;}#mermaid-1693925847428 .sgraph>*{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1693925847428 .sgraph span{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1693925847428 .cluster>*{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}#mermaid-1693925847428 .cluster span{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}`}</style><g parentName="svg"><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "9",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 0 L 10 5 L 0 10 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "0",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 5 L 10 10 L 10 0 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "11",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleEnd"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "-1",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleStart"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "12",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "-1",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><g parentName="g" {...{
            "className": "root"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "transform": "translate(-7.5, -8)",
                "className": "root"
              }}><g parentName="g" {...{
                  "className": "clusters"
                }}><g parentName="g" {...{
                    "id": "Main",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "346.94707107543945",
                      "width": "2750.78125",
                      "y": "8",
                      "x": "8",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1383.390625, 13)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "PluginServerIngestion",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "168",
                      "width": "1147.015625",
                      "y": "76.96471405029297",
                      "x": "574.0625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1082.78125, 81.96471405029297)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "129.578125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Ingestion server`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "PluginServerAsync",
                    "className": "cluster plugingraph plugingraph"
                  }}><rect parentName="g" {...{
                      "height": "177.5",
                      "width": "632.640625",
                      "y": "157.44707107543945",
                      "x": "2101.140625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(2365.75, 162.44707107543945)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "103.421875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Async server`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "MainThreadIngestion",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "112",
                      "width": "196.109375",
                      "y": "102.96471405029297",
                      "x": "599.0625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(649.25, 107.96471405029297)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "95.734375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Main thread`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "WorkerThreadIngestion",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "104",
                      "width": "730.640625",
                      "y": "120.96471405029297",
                      "x": "965.4375",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1273.8046875, 125.96471405029297)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "113.90625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Worker thread`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "MainThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "116.75",
                      "width": "196.109375",
                      "y": "187.44707107543945",
                      "x": "2126.140625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(2176.328125, 192.44707107543945)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "95.734375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Main thread`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "WorkerThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "123",
                      "width": "216.265625",
                      "y": "186.69707107543945",
                      "x": "2492.515625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(2543.6953125, 191.69707107543945)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "113.90625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Worker thread`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "edgePaths"
                }}><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Django LE-KafkaPlugins",
                    "id": "L-Django-KafkaPlugins-0",
                    "d": "M187.65625,162.96471405029297L191.82291666666666,162.96471405029297C195.98958333333334,162.96471405029297,204.32291666666666,162.96471405029297,212.73958333333334,163.0480473836263C221.15625,163.13138071695963,229.65625,163.2980473836263,233.90625,163.38138071695963L238.15625,163.46471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-KafkaPlugins LE-KafkaConsumerIngestion",
                    "id": "L-KafkaPlugins-KafkaConsumerIngestion-0",
                    "d": "M331.59375,163.46471405029297L351.7578125,163.38138071695963C371.921875,163.2980473836263,412.25,163.13138071695963,452.6614583333333,163.0480473836263C493.0729166666667,162.96471405029297,533.5677083333334,162.96471405029297,557.9817708333334,162.96471405029297C582.3958333333334,162.96471405029297,590.7291666666666,162.96471405029297,599.0625,162.96471405029297C607.3958333333334,162.96471405029297,615.7291666666666,162.96471405029297,619.8958333333334,162.96471405029297L624.0625,162.96471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumerIngestion LE-PiscinaIngestion",
                    "id": "L-KafkaConsumerIngestion-PiscinaIngestion-0",
                    "d": "M770.171875,148.06390933353734L774.3385416666666,147.2140434529966C778.5052083333334,146.36417757245587,786.8385416666666,144.66444581137443,795.171875,143.8145799308337C803.5052083333334,142.96471405029297,811.8385416666666,142.96471405029297,820.3481336805556,145.13138071695963C828.8577256944445,147.2980473836263,837.5435763888889,151.63138071695963,841.8865017361112,153.7980473836263L846.2294270833333,155.96471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumerIngestion LE-PiscinaIngestion",
                    "id": "L-KafkaConsumerIngestion-PiscinaIngestion-1",
                    "d": "M770.171875,162.96471405029297L774.3385416666666,162.96471405029297C778.5052083333334,162.96471405029297,786.8385416666666,162.96471405029297,795.171875,162.96471405029297C803.5052083333334,162.96471405029297,811.8385416666666,162.96471405029297,820.171875,163.657624708125C828.5052083333334,164.35053536595709,836.8385416666666,165.73635668162117,841.0052083333334,166.42926733945322L845.171875,167.1221779972853"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumerIngestion LE-PiscinaIngestion",
                    "id": "L-KafkaConsumerIngestion-PiscinaIngestion-2",
                    "d": "M761.2298677884615,179.96471405029297L766.8868689903846,181.46471405029297C772.5438701923076,182.96471405029297,783.8578725961538,185.96471405029297,793.6815404647435,187.46471405029297C803.5052083333334,188.96471405029297,811.8385416666666,188.96471405029297,820.171875,187.8560569977617C828.5052083333334,186.7473999452304,836.8385416666666,184.5300858401678,841.0052083333334,183.42142878763653L845.171875,182.31277173510523"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-PiscinaIngestion LE-ProcessEvent",
                    "id": "L-PiscinaIngestion-ProcessEvent-0",
                    "d": "M915.4375,172.96471405029297L919.6041666666666,172.96471405029297C923.7708333333334,172.96471405029297,932.1041666666666,172.96471405029297,940.4375,172.96471405029297C948.7708333333334,172.96471405029297,957.1041666666666,172.96471405029297,965.4375,172.96471405029297C973.7708333333334,172.96471405029297,982.1041666666666,172.96471405029297,986.2708333333334,172.96471405029297L990.4375,172.96471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-ProcessEvent LE-PrepareEvent",
                    "id": "L-ProcessEvent-PrepareEvent-0",
                    "d": "M1169.796875,172.96471405029297L1173.9635416666667,172.96471405029297C1178.1302083333333,172.96471405029297,1186.4635416666667,172.96471405029297,1194.796875,172.96471405029297C1203.1302083333333,172.96471405029297,1211.4635416666667,172.96471405029297,1215.6302083333333,172.96471405029297L1219.796875,172.96471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-PrepareEvent LE-EmitToBuffer",
                    "id": "L-PrepareEvent-EmitToBuffer-0",
                    "d": "M1342.890625,172.96471405029297L1347.0572916666667,172.96471405029297C1351.2239583333333,172.96471405029297,1359.5572916666667,172.96471405029297,1367.890625,172.96471405029297C1376.2239583333333,172.96471405029297,1384.5572916666667,172.96471405029297,1388.7239583333333,172.96471405029297L1392.890625,172.96471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-EmitToBuffer LE-CreateEvent",
                    "id": "L-EmitToBuffer-CreateEvent-0",
                    "d": "M1509.453125,172.96471405029297L1513.6197916666667,172.96471405029297C1517.7864583333333,172.96471405029297,1526.1197916666667,172.96471405029297,1534.453125,172.96471405029297C1542.7864583333333,172.96471405029297,1551.1197916666667,172.96471405029297,1555.2864583333333,172.96471405029297L1559.453125,172.96471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-CreateEvent LE-KafkaCH",
                    "id": "L-CreateEvent-KafkaCH-0",
                    "d": "M1671.078125,172.96471405029297L1675.2447916666667,172.96471405029297C1679.4114583333333,172.96471405029297,1687.7447916666667,172.96471405029297,1696.078125,172.96471405029297C1704.4114583333333,172.96471405029297,1712.7447916666667,172.96471405029297,1736.6302083333333,172.96471405029297C1760.515625,172.96471405029297,1799.953125,172.96471405029297,1839.4739583333333,173.0480473836263C1878.9947916666667,173.13138071695963,1918.5989583333333,173.2980473836263,1938.4010416666667,173.38138071695963L1958.203125,173.46471405029297"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-KafkaCH LE-ClickHouse",
                    "id": "L-KafkaCH-ClickHouse-0",
                    "d": "M2026.3724934711167,148.1965825214098L2034.667182059264,138.2442116053659C2042.9618706474112,128.29184068932202,2059.5512478237056,108.38709885723426,2072.0126030785195,98.43472794119037C2084.4739583333335,88.48235702514648,2092.8072916666665,88.48235702514648,2101.140625,88.48235702514648C2109.4739583333335,88.48235702514648,2117.8072916666665,88.48235702514648,2129.7109375,88.48235702514648C2141.6145833333335,88.48235702514648,2157.0885416666665,88.48235702514648,2164.8255208333335,88.48235702514648L2172.5625,88.48235702514648"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-KafkaCH LE-KafkaConsumer",
                    "id": "L-KafkaCH-KafkaConsumer-0",
                    "d": "M2027.7227263810594,197.3826126692337L2035.7923761508828,205.851689070268C2043.8620259207062,214.32076547130228,2060.001325460353,231.25891827337088,2072.2376418968433,239.72799467440518C2084.4739583333335,248.19707107543945,2092.8072916666665,248.19707107543945,2101.140625,248.19707107543945C2109.4739583333335,248.19707107543945,2117.8072916666665,248.19707107543945,2126.140625,248.19707107543945C2134.4739583333335,248.19707107543945,2142.8072916666665,248.19707107543945,2146.9739583333335,248.19707107543945L2151.140625,248.19707107543945"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-0",
                    "d": "M2297.25,233.29626635868382L2301.4166666666665,232.4464004781431C2305.5833333333335,231.59653459760239,2313.9166666666665,229.89680283652092,2322.25,229.0469369559802C2330.5833333333335,228.19707107543945,2338.9166666666665,228.19707107543945,2347.25,229.58289239110357C2355.5833333333335,230.96871370676766,2363.9166666666665,233.7403563380959,2368.0833333333335,235.12617765376L2372.25,236.51199896942413"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-1",
                    "d": "M2297.25,248.19707107543945L2301.4166666666665,248.19707107543945C2305.5833333333335,248.19707107543945,2313.9166666666665,248.19707107543945,2322.25,248.19707107543945C2330.5833333333335,248.19707107543945,2338.9166666666665,248.19707107543945,2347.25,248.19707107543945C2355.5833333333335,248.19707107543945,2363.9166666666665,248.19707107543945,2368.0833333333335,248.19707107543945L2372.25,248.19707107543945"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-2",
                    "d": "M2290.2123298267325,265.19707107543945L2295.551941522277,266.57207107543945C2300.8915532178216,267.94707107543945,2311.570776608911,270.69707107543945,2321.077054971122,272.07207107543945C2330.5833333333335,273.44707107543945,2338.9166666666665,273.44707107543945,2347.25,271.6974716644135C2355.5833333333335,269.9478722533876,2363.9166666666665,266.4486734313357,2368.0833333333335,264.69907402030975L2372.25,262.9494746092838"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-AsyncHandlers",
                    "id": "L-Piscina-AsyncHandlers-0",
                    "d": "M2442.515625,248.19707107543945L2446.6822916666665,248.19707107543945C2450.8489583333335,248.19707107543945,2459.1822916666665,248.19707107543945,2467.515625,248.19707107543945C2475.8489583333335,248.19707107543945,2484.1822916666665,248.19707107543945,2492.515625,248.19707107543945C2500.8489583333335,248.19707107543945,2509.1822916666665,248.19707107543945,2513.3489583333335,248.19707107543945L2517.515625,248.19707107543945"
                  }}></path></g><g parentName="g" {...{
                  "className": "edgeLabels"
                }}><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(452.578125, 162.96471405029297)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-96.484375, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "192.96875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`events_plugin_ingestion`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1839.390625, 172.96471405029297)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-93.3125, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "186.625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`clickhouse_events_json`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "nodes"
                }}><g parentName="g" {...{
                    "transform": "translate(2224.1953125, 88.48235702514648)",
                    "id": "flowchart-ClickHouse-104",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-51.6328125,-33.96471353275378)",
                      "d": "M 0,11.309809021835854 a 51.6328125,11.309809021835854 0,0,0 103.265625 0 a 51.6328125,11.309809021835854 0,0,0 -103.265625 0 l 0,45.309809021835854 a 51.6328125,11.309809021835854 0,0,0 103.265625 0 l 0,-45.309809021835854",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-44.1328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "88.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`ClickHouse`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(110.328125, 162.96471405029297)",
                    "id": "flowchart-Django-109",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "154.65625",
                      "y": "-17",
                      "x": "-77.328125",
                      "ry": "0",
                      "rx": "0",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-69.828125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "139.65625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Capture endpoint`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(284.375, 162.96471405029297)",
                    "id": "flowchart-KafkaPlugins-107",
                    "className": "node default default"
                  }}><polygon parentName="g" {...{
                      "style": {},
                      "transform": "translate(-46.71875,46.71875)",
                      "className": "label-container",
                      "points": "46.71875,0 93.4375,-46.71875 46.71875,-93.4375 0,-46.71875"
                    }}></polygon><g parentName="g" {...{
                      "transform": "translate(-22.21875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "44.4375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(697.1171875, 162.96471405029297)",
                    "id": "flowchart-KafkaConsumerIngestion-110",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "146.109375",
                      "y": "-17",
                      "x": "-73.0546875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-65.5546875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "131.109375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka Consumer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(880.3046875, 172.96471405029297)",
                    "id": "flowchart-PiscinaIngestion-118",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "70.265625",
                      "y": "-17",
                      "x": "-35.1328125",
                      "ry": "0",
                      "rx": "0",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-27.6328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "55.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Piscina`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1080.1171875, 172.96471405029297)",
                    "id": "flowchart-ProcessEvent-111",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "179.359375",
                      "y": "-17",
                      "x": "-89.6796875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-82.1796875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "164.359375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`pluginsProcessEvent`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1281.34375, 172.96471405029297)",
                    "id": "flowchart-PrepareEvent-115",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "123.09375",
                      "y": "-17",
                      "x": "-61.546875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-54.046875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "108.09375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`prepareEvent`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1451.171875, 172.96471405029297)",
                    "id": "flowchart-EmitToBuffer-116",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "116.5625",
                      "y": "-17",
                      "x": "-58.28125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-50.78125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "101.5625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`emitToBuffer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1615.265625, 172.96471405029297)",
                    "id": "flowchart-CreateEvent-112",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "111.625",
                      "y": "-17",
                      "x": "-55.8125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-48.3125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "96.625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`createEvent`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2004.421875, 172.96471405029297)",
                    "id": "flowchart-KafkaCH-108",
                    "className": "node default default"
                  }}><polygon parentName="g" {...{
                      "style": {},
                      "transform": "translate(-46.71875,46.71875)",
                      "className": "label-container",
                      "points": "46.71875,0 93.4375,-46.71875 46.71875,-93.4375 0,-46.71875"
                    }}></polygon><g parentName="g" {...{
                      "transform": "translate(-22.21875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "44.4375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2224.1953125, 248.19707107543945)",
                    "id": "flowchart-KafkaConsumer-119",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "146.109375",
                      "y": "-17",
                      "x": "-73.0546875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-65.5546875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "131.109375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka Consumer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2407.3828125, 248.19707107543945)",
                    "id": "flowchart-Piscina-121",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "70.265625",
                      "y": "-17",
                      "x": "-35.1328125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-27.6328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "55.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Piscina`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2600.6484375, 248.19707107543945)",
                    "id": "flowchart-AsyncHandlers-120",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "53",
                      "width": "166.265625",
                      "y": "-26.5",
                      "x": "-83.1328125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-75.6328125, -19)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "38",
                        "width": "151.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`runAsyncHandlers`}<br parentName="span"></br>{`onEvent,webhooks`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      